<template>
  <transition name="fade" mode="out-in" appear>
    <VSpinner v-if="isLoading && spinner" key="loading" class="offset-top-4" />
    <VNotification v-else-if="isLoading" key="loading" type="LOADING" />
    <VNotification v-else-if="isSearchError" key="error" :type="searchWarningMessage ? 'WARNING' : 'ERROR'" :closable="closable" @close="$emit('close')">
      <span v-if="isSearchErrorNoData">{{ $t('common.errorNoData') }}</span>
      <span v-else-if="isSearchErrorInvalidFormData">{{ $t('common.errorInvalidFormData') }}</span>
      <span v-else-if="searchErrorCode">{{ getErrorText }}</span>
      <span v-else>
        {{ searchErrorMessage || searchWarningMessage }}
      </span>
    </VNotification>
    <VNotification v-else-if="isSearchSuccess && hasSlotData" key="success" type="SUCCESS">
      <slot></slot>
    </VNotification>
  </transition>
</template>

<script>
import VSpinner from '@/components/Spinner';
import VNotification from '@/components/Notification';

export default {
  name: 'SearchFormStatus',

  components: {
    VSpinner,
    VNotification,
  },

  props: {
    spinner: {
      type: Boolean,
      required: false,
    },

    hideLoading: {
      type: Boolean,
      required: false,
    },

    closable: {
      type: Boolean,
      required: false,
    },

    isSearchLoading: {
      type: Boolean,
      required: true,
    },

    isSearchSuccess: {
      type: Boolean,
      required: true,
    },

    isSearchErrorNoData: {
      type: Boolean,
      required: true,
    },

    isSearchErrorInvalidFormData: {
      type: Boolean,
      required: true,
    },

    searchErrorMessage: {
      type: String,
      required: true,
    },

    searchWarningMessage: {
      type: String,
      required: true,
    },

    searchErrorCode: {
      type: String,
      required: true,
    },
  },

  computed: {
    getErrorText() {
      return this.$t(this.searchErrorCode);
    },

    isLoading() {
      return this.isSearchLoading && !this.hideLoading;
    },

    isSearchError() {
      return (
        this.isSearchErrorNoData || this.isSearchErrorInvalidFormData || !!this.searchWarningMessage || !!this.searchErrorMessage || !!this.searchErrorCode
      );
    },

    hasSlotData() {
      return this.$scopedSlots.default;
    },
  },
};
</script>
